import React from 'react';

import { useQuery } from '@apollo/client';
import { GET_CONTACTS } from 'Queries/Queries';
import PropTypes from 'prop-types';

import 'components/ExpertSearch/ExpertSearch.sass';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';

import { ExpertSearchResult } from './ExpertSearchResult';

export const ExpertSearchDropdownExpert = ({ zip, city, district, tile, onReset }) => {
  const { loading, error, data } = useQuery(GET_CONTACTS, {
    variables: {
      zip,
      city,
      district,
      tile,
    },
  });

  if (loading) return <LoadingIndicator />;
  if (error) return <div>(!) ERROR (!)</div>;

  return data.contacts.length > 0 ? <ExpertSearchResult data={data} onReset={onReset} /> : null;
};

ExpertSearchDropdownExpert.propTypes = {
  zip: PropTypes.string,
  city: PropTypes.string,
  district: PropTypes.string,
  tile: PropTypes.string,
  onReset: PropTypes.func,
};

ExpertSearchDropdownExpert.defaultProps = {
  zip: '',
  city: '',
  district: '',
  tile: '',
  onReset: () => {},
};
